<template>
  <div class="main user-layout-register">
    <div v-if="visable" style="padding: 30px">
<!--      <div style="font-weight: bold;font-size: 20px;color: #333333;">Hello~</div>-->
<!--      <div style="font-size: 14px;margin-top: 10px;margin-bottom: 16px;">-->
<!--        <span>欢迎</span>-->
<!--        <span style="color: blue;margin: 0 4px;">登录</span>-->
<!--        <span>FrameFlash 管理端！</span>-->
<!--      </div>-->
      <a-form-model ref="form" :model="form" :rules="rules" >
        <a-alert
          v-if="isRegisterError"
          type="error"
          showIcon
          style="margin-bottom: 24px;"
          :message="registerErrorInfo"
          closable
          :after-close="handleCloseRegisterError"
        />
        <a-form-model-item prop="userEmail">
          <a-input v-model="form.userEmail" size="large" autocomplete="off" placeholder="请输入邮箱"  >
            <a-icon  slot="prefix" type="mail" />" type="email" :style="{ color: 'rgba(0,0,0,.6)' }" />
          </a-input>
        </a-form-model-item>
        <a-row :gutter="16" v-if="captchaEnabled">
          <a-col class="gutter-row" :span="16">
            <a-form-model-item prop="code">
              <a-input v-model="form.code" size="large" type="number" :maxLength="6" autocomplete="off" placeholder="验证码">
                <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.6)' }"/>
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col class="gutter-row" :span="8">
            <a-button :disabled="isFetching" @click="fetchCaptcha">{{ buttonText }}</a-button>
          </a-col>
          <!-- <a-col class="gutter-row" :span="8">
            <img class="getCaptcha" :src="codeUrl" @click="getCode">
          </a-col> -->
        </a-row>
        <a-form-model-item has-feedback prop="password">

          <a-input-password v-model="form.password" size="large" autocomplete="off" placeholder="请输入6-16位密码，区分大小写" :maxLength="16" >
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.6)' }" />
          </a-input-password>
        </a-form-model-item>


        <a-form-model-item prop="userPhone">
          <a-input v-model="form.userPhone" size="large" autocomplete="off" placeholder="请输入手机号"  :maxLength="11">
            <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.6)' }" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item prop="银行">
          <a-input v-model="form.bankName" size="large" autocomplete="off" placeholder="请输入银行名称"  :maxLength="-1">
            <a-icon slot="prefix" type="bank" :style="{ color: 'rgba(0,0,0,.6)' }" />
          </a-input>
        </a-form-model-item>


        <a-form-model-item prop="开户行">
          <a-input v-model="form.bankAddress" size="large" autocomplete="off" placeholder="请输入开户行"  :maxLength="-1">
            <a-icon slot="prefix" type="home" :style="{ color: 'rgba(0,0,0,.6)' }" />
          </a-input>
        </a-form-model-item>



        <a-form-model-item prop="bankNo" >
          <a-input v-model="form.bankNo" size="large" autocomplete="off" placeholder="请输入银行卡号" :maxLength="-1" >
            <a-icon slot="prefix" type="dollar" :style="{ color: 'rgba(0,0,0,.6)' }" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item  prop="realName" >
          <a-input v-model="form.realName" size="large" autocomplete="off" placeholder="请输入真实姓名" :maxLength="-1" >
            <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.6)' }" />
          </a-input>
        </a-form-model-item>

<!--        <a-form-model-item  prop="inviteCode" >-->
<!--          <a-input disabled v-model="form.inviteCode" size="large" autocomplete="off" placeholder="上级邀请码" :maxLength="-1" >-->
<!--            <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.6)' }" />-->
<!--          </a-input>-->
<!--        </a-form-model-item>-->


        <a-form-item>
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="register-button"
            :loading="registering"
            @click.stop.prevent="handleRegister"
            :disabled="registering"
          >
            确定
          </a-button>
        </a-form-item>
        <router-link  :to="{ name: 'login' }"> <span class="text-999"> 已有账户？</span> <span class="text-theme">立即登录</span>  </router-link>
        <error ref="error"></error>
      </a-form-model>
    </div>

    <div v-if="successFlag">
      <template>
        <a-result
          status="success"
          title="注册成功"
          sub-title="注册成功，请等待审核通过后登录系统"
        >
          <template #extra>
            <a-button key="console" type="primary" @click="getToLogin()">跳转登录</a-button>
          </template>
        </a-result>
      </template>
    </div>
  </div>

</template>

<script>
import {getCodeImg, register, getCodes, registerDis} from '@/api/login'
import error from '../error/error'
export default {
  name: 'forget',
  components: {
    error
  },
  data () {
    const validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,16}$/.test(value)) {
        callback(new Error('请输入6-16位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种'))
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.form.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码确认'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      codeUrl: '',
      isRegisterError: false,
      successFlag: false,
      visable: true,
      topDistributorRait: 100,
      topGoodsDistributorRait: 100,
      registerErrorInfo: '',
      form: {
        mobile: '',
        password: '',
        confirmPassword: '',
        code: '',
        uuid: ''
      },
      isFetching: false, // 控制获取验证码按钮是否可点击的标志
      buttonText: '获取验证码', // 按钮上的文字
      time: 60, // 倒计时60S,@Number
				beginning: false, // 显示倒计时,@Boolean
				timer: null, // 计时器,@Function
      rules: {
        userEmail: [
          { required: true, trigger: 'blur', message: '请输入邮箱' },
          {  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur', message: '请输入您的密码' },
          { required: true, validator: validateNewPass, trigger: 'blur' }
        ],
        userPhone: [
          { required: true, trigger: 'blur', message: '请输入您的手机号' },
          {pattern: /^1\d{10}$/, message: '请输入11位手机号', trigger: 'blur'}
        ],
        bankName: [
          { required: true, trigger: 'blur', message: '请输入银行名称' },
        ],
        bankAddress: [
          { required: true, trigger: 'blur', message: '请输入开户行名称' },
        ],
        bankNo: [
          { required: true, trigger: 'blur', message: '请输入银行卡号' },
          {pattern: /^\d{13,19}$/, message: '请输入正确13-19位的银行卡号', trigger: 'blur'}
        ],
        realName: [
          { required: true, trigger: 'blur', message: '请输入真实姓名' },
        ],
        code: [{ required: true, trigger: 'change', message: '请输入验证码' }]
      },
      registerBtn: false,
      registering: false,
      captchaEnabled: true
    }
  },
  computed: {},
  created () {

    this.getCode()

  },

  mounted () {
    console.log('this.$route.query')
    console.log(this.$route.params);
    this.getInvicode()
  },
  destroyed () {
    // clearInterval(this.timer)
  },
  methods: {
    // 获取验证码
    getInvicode() {
      var strings =this.$route.params.code;
      if(strings == 'fromLogin') {
        this.form.inviteCode = null;
        this.visable = true;
        this.$refs['error'].hide();
      } else {
        if (strings) {
          this.form.inviteCode = strings
          this.visable = true;
          this.$refs['error'].hide();
        } else {
          this.visable = false;
          this.$refs['error'].show();

        }
      }

    },
    fetchCaptcha(){
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.userEmail)) {
        this.$message.error('请输入正确的邮箱')
        return false
      }
      getCodes({userEmail: this.form.userEmail, inviteCode: this.form.inviteCode}).then((res) => {
        if (this.captchaEnabled) {

        }
      })
      this.beginning = true;
      this.isFetching = true;
      // 清除倒计时,防抖作用
      clearInterval(this.timer);
      this.time = 60; // 每次点击重置倒计时
      this.buttonText = this.time + 's后重新获取'; // 立即更新一次
      this.timer = setInterval(() => {
        this.time--;
        this.buttonText = this.time + 's后重新获取'; // 每秒都更新
        if (this.time <= 0) {
          clearInterval(this.timer);
          this.buttonText = '获取验证码';
          this.isFetching = false;
        }
      }, 1000);
    },
    getCode () {

      getCodeImg().then((res) => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.img
          this.form.uuid = res.uuid
        }
      })
    },
    handleRegister () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.registering = true
          registerDis(this.form)
            .then(res => this.registerSuccess(res))
            .catch(err => this.requestFailed(err))
            .finally(() => {
              // this.registering = false
            })
        } else {
          setTimeout(() => {
            this.registering = false
          }, 600)
        }
      })
    },

    getToLogin() {
      this.$router.push({ path: '/login' })
    },
    registerSuccess (res) {
      this.visable=false;
      this.successFlag=true;
      // this.$router.push({ path: '/login' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '注册成功！'
        })
      }, 1000)
      this.handleCloseRegisterError()
    },
    requestFailed (err) {
      this.isRegisterError = true
      this.registerErrorInfo = err
      this.form.code = ''
      // if (this.captchaEnabled) {
      //   this.getCode()
      // }
    },
    handleCloseRegisterError () {
      this.isRegisterError = false
      this.registerErrorInfo = ''
    }

  }
}
</script>
<style lang="less">
.user-register {

  &.error {
    color: #ff0000;
  }
  &.warning {
    color: #ff7e05;
  }
  &.success {
    color: #52c41a;
  }
}
.user-layout-register {
  //height: 50vh;
  .ant-input-group-addon:first-child {
    background-color: #fff;
  }
}
</style>
<style lang="less" scoped>
.user-layout-register {
  & > h3 {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }
  .register-button {
    width: 100%;
  }
  .login {
   display: flex;
   align-items: center;
   justify-content: center;
    line-height: 40px;
  }
}
/deep/.ant-input-affix-wrapper  .ant-input{
    background: #F8FAFA;
    border: 0;
  }
</style>
